module.exports = __webpack_public_path__ + "img/service-options-swoop-navy.48f4c210.jpg";